module.exports = "<example-shell\n  exampleId=\"dense\" [title]=\"title\" [summary]=\"summary\" [dataSnippet]=\"dataSnippet\" [events]=\"events\" (clear)=\"clearEvents()\">\n  <stackline-data-table\n    title=\"Dense operations table\"\n    [columns]=\"ticketColumns\"\n    [data]=\"tickets\"\n    [dense]=\"true\"\n    [striped]=\"true\"\n    [highlightOnHover]=\"true\">\n  </stackline-data-table>\n</example-shell>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/dense/dense.component.html
// module id = ./src/app/examples/dense/dense.component.html
// module chunks = main